import { ChildInputType } from '../types';
import { CustomField } from '../worktimeReportRedux';

export const customEntityOptions = (customEntities: CustomField[]) =>
  customEntities.map(entity => ({
    label: entity.name,
    value: entity.code,
  })) as ChildInputType[];
